export const TYPES = [
    'style', 'ratio', 'gap', 'flex', 'mt', 'mb', 'ml', 'mr', 'mh', 'mv', 'm', 'my', 'mx',
    'pt', 'pb', 'pl', 'pr', 'ph', 'pv', 'p', 'py', 'px', 'alignItems', 'justifyContent', 'alignSelf', 'flexWrap',
    'width', 'height', 'backgroundColor', 'bg', 'rounded', 'opacity', 'fontWeight', 'transform', 'zIndex', 'position', 
    'textAlign', 'borderRadius', 'borderWidth', 'borderColor', 'elevation', "w", "h", "flexDir", "flexGrow", "flexShrink", "flexBasis",    
    'vh', 'vw', 'aspectRatio', 'display', 'flexDirection', 'borderTopWidth', 'borderBottomWidth', 'borderLeftWidth', 'borderRightWidth',
    'borderTopColor', 'borderBottomColor', 'borderLeftColor', 'borderRightColor', 'borderTopLeftRadius', 'borderTopRightRadius',
    'vh', 'vw', 'aspectRatio', "maxW", "maxH", "minW", "minH", "bgColor", "backgroundColor", "overflow", "display", "left", "right", "top", "bottom"
];

export const COLOR_TYPES = [
    'color', 
    'bg',
    'bgColor',
    'backgroundColor', 
    'borderColor', 
    'shadowColor', 
    'textShadowColor', 
    'tintColor',
    'borderTopColor',
    'borderBottomColor',
    'borderLeftColor',
    'borderRightColor',
];

export const CASTER = {
    'pt': 'paddingTop',
    'pb': 'paddingBottom',
    'pl': 'paddingLeft',
    'pr': 'paddingRight',
    'ph': 'paddingHorizontal',
    'pv': 'paddingVertical',
    'py': 'paddingVertical',
    'px': 'paddingHorizontal',
    'mt': 'marginTop',
    'mb': 'marginBottom',
    'ml': 'marginLeft',
    'mr': 'marginRight',
    'mh': 'marginHorizontal',
    'mv': 'marginVertical',
    'my': 'marginVertical',
    'mx': 'marginHorizontal',
    'ratio': 'aspectRatio',
    'bg': 'backgroundColor',
    'p': 'padding',
    'm': 'margin',
    "w" : "width",
    "h" : "height",
    "flexDir" : "flexDirection",
    "maxW" : "maxWidth",
    "maxH" : "maxHeight",
    "minW" : "minWidth",
    "minH" : "minHeight",
    "bgColor" : "backgroundColor"
};